export default __webpack_public_path__ + "static/media/manejebem-logo.99cd86cb.svg";